// extracted by mini-css-extract-plugin
module.exports = {"flag":"okCJS73UvzyeqHlSDN_Xh"};